import {
  GET_LEGAL_CHANGES,
  SET_LEGAL_CHANGES,
  SET_NEW_LEGAL_CHANGES,
  GET_LEGAL_CHANGES_ERROR,
  RESET_LEGAL_CHANGES,
  SET_LEGAL_CHANGE_FILTERS,
  RESET_LEGAL_CHANGE_FILTERS
} from './types'
import { RESET_TOKEN, SET_ACTIVE_WORKSPACE } from 'utils/auth/types'

const initialLegalChangeFilters = {
  status: null,
  dateRange: null
}

const initialState = {
  legalChanges: [],
  legalChangesNext: null,
  isLoadingLegalChanges: false,
  newLegalChangesCount: 0,
  legalChangeFilters: initialLegalChangeFilters,
  filtersWorkspaceId: null
}

const legalChangesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEGAL_CHANGES:
      return {
        ...state,
        isLoadingLegalChanges: true
      }
    case SET_LEGAL_CHANGES:
      return {
        ...state,
        legalChanges: action.payload.legalChanges,
        legalChangesNext: action.payload.legalChangesNext,
        newLegalChangesCount: action.payload.newLegalChangesCount,
        isLoadingLegalChanges: false
      }
    case SET_NEW_LEGAL_CHANGES:
      return {
        ...state,
        newLegalChangesCount: action.payload.newLegalChangesCount
      }
    case GET_LEGAL_CHANGES_ERROR:
      return {
        ...state,
        isLoadingLegalChanges: false
      }
    case RESET_LEGAL_CHANGES:
      return {
        ...state,
        legalChanges: [],
        isLoadingLegalChanges: false
      }
    case SET_LEGAL_CHANGE_FILTERS:
      return {
        ...state,
        legalChangeFilters: {
          ...state.legalChangeFilters,
          ...action.payload.filters
        }
      }
    case RESET_LEGAL_CHANGE_FILTERS:
      // The date range has its own button and clear badge, so clearing the
      // filter menu leaves it in place
      return {
        ...state,
        legalChangeFilters: {
          ...initialLegalChangeFilters,
          dateRange: state.legalChangeFilters.dateRange
        }
      }
    case SET_ACTIVE_WORKSPACE: {
      const workspaceId = action.payload.activeWorkspace.id
      if (workspaceId === state.filtersWorkspaceId) {
        return state
      }
      return {
        ...state,
        legalChangeFilters: initialLegalChangeFilters,
        filtersWorkspaceId: workspaceId
      }
    }
    case RESET_TOKEN:
      return {
        ...state,
        legalChangeFilters: initialLegalChangeFilters,
        filtersWorkspaceId: null
      }
    default:
      return state
  }
}

export default legalChangesReducer
